export const ID_REQUIRED_MESSAGE = "아이디를 입력해 주세요.";
export const PASSWORD_REQUIRED_MESSAGE = "비밀번호를 입력해 주세요.";
export const PASSWORD_CONFIRM_WARNING_MESSAGE = "비밀번호와 일치하지 않습니다.";
export const PASSWORD_LENGTH_WARNING_MESSAGE = '8~15자 이내로 입력해주세요'
export const NAME_REQUIRED_MESSAGE = "이름을 입력해 주세요.";
export const EMAIL_REQUIRED_MESSAGE = "이메일을 입력해 주세요.";
export const EMAIL_WARNING_MESSAGE = "올바르지 않은 이메일 형식입니다.";
export const PHONE_WARNING_MESSAGE = "휴대번호는 기호 없이 숫자로만 입력해주세요.";
export const PHONE_REQUIRED_MESSAGE = "휴대번호를 입력해 주세요.";
